import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { VersionsService } from "./versions.service";
import { VersionsComponent } from "./versions.component";
import { DialogModule } from "primeng/dialog";
import { DataViewModule } from "primeng/dataview";
import { ProgressSpinnerModule } from "primeng/progressspinner";

@NgModule({
    declarations: [
        VersionsComponent

    ],
    exports: [VersionsComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        ProgressSpinnerModule,
        DialogModule,
        DataViewModule
    ],
    providers: [
        VersionsService
    ]
})

export class VersionsModule { }